import {createContext} from 'react';

export interface IProductListFunctionalityProps {
    countIndicator?: boolean;
    collectionSwitcher?: boolean;
    pagination?: boolean;
    viewSwitcher?: boolean;
    sortingSelector?: boolean;
    title?: boolean;
    mobileHeader?: boolean;
    showRelatedCollectionList?: boolean;
    searchCountIndicator?: boolean;
    collectionFilterButton?: boolean;
    orderFilterButton?: boolean;
}

export const ProductListPageFunctionalityContext = createContext<IProductListFunctionalityProps>({
    collectionFilterButton: false,
    collectionSwitcher: true,
    countIndicator: true,
    mobileHeader: true,
    orderFilterButton: false,
    pagination: true,
    searchCountIndicator: false,
    showRelatedCollectionList: false,
    sortingSelector: true,
    title: true,
    viewSwitcher: true,
});

export const PAGINATION_DEFAULT = {pageNumber: 1, pageSize: 32, totalCount: 0};
